<template>
  <header class="MHeader" :class="{ 'MHeader--fixed': fixed }">
    <slot></slot>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MHeader',
  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  }
})
</script>
<style lang="scss" scoped>
@include b(MHeader) {
  background-color:rgba(127, 109, 164, 0.1);
  @include m(fixed) {
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 10;
  }
}
</style>
